import moment from "moment";

export default function checkExpiredJWT(expireDate) {
    const now = moment();
    const expire = moment(expireDate, 'x');

    return expire.isBefore(now, 'minute');
}
